import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const GradFairRegisterModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "GradFairRegisterModalContainer" */
      './GradFairRegisterModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
